<div class="home-title">
    <div class="symbol">
        <div class="line-vertical line-v1"></div>
        <div class="line-vertical line-v2"></div>
        <div class="line-horizontal line-h1"></div>
        <div class="line-horizontal line-h2"></div>
        <div class="block block-1"></div>
        <div class="block block-2"></div>
        <div class="block block-3"></div>
        <div class="block block-4"></div>
        <div class="title">boanalys<span class="tm">™</span></div>
    </div>
    <h2>analysera din bostadsrättsförening</h2>
     <!--<h2 style="color: red; font-weight: bold; margin-bottom: 0px;">OBS! Vi har för tillfället tekniska problem. Vi arbetar med att lösa det så fort som möjligt. En av leverantörerna har oföreberett underhåll.</h2>
    <h2 style="color: red;">Problemet uppstod 2025-05-20 klockan 17:00 CEST</h2>-->
    </div>